/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicSignInRouteImport } from './routes/_public/sign-in'
import { Route as AuthDashboardIndexRouteImport } from './routes/_auth/dashboard/index'
import { Route as AuthLocationWikiLocationIdRouteImport } from './routes/_auth/location-wiki/$locationId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicSignInRoute = PublicSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRoute,
} as any)
const AuthDashboardIndexRoute = AuthDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLocationWikiLocationIdRoute =
  AuthLocationWikiLocationIdRouteImport.update({
    id: '/location-wiki/$locationId',
    path: '/location-wiki/$locationId',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof PublicSignInRoute
  '/location-wiki/$locationId': typeof AuthLocationWikiLocationIdRoute
  '/dashboard': typeof AuthDashboardIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof PublicSignInRoute
  '/location-wiki/$locationId': typeof AuthLocationWikiLocationIdRoute
  '/dashboard': typeof AuthDashboardIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/sign-in': typeof PublicSignInRoute
  '/_auth/location-wiki/$locationId': typeof AuthLocationWikiLocationIdRoute
  '/_auth/dashboard/': typeof AuthDashboardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/sign-in' | '/location-wiki/$locationId' | '/dashboard'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/sign-in' | '/location-wiki/$locationId' | '/dashboard'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/_public/sign-in'
    | '/_auth/location-wiki/$locationId'
    | '/_auth/dashboard/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/dashboard/': {
      id: '/_auth/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/location-wiki/$locationId': {
      id: '/_auth/location-wiki/$locationId'
      path: '/location-wiki/$locationId'
      fullPath: '/location-wiki/$locationId'
      preLoaderRoute: typeof AuthLocationWikiLocationIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLocationWikiLocationIdRoute: typeof AuthLocationWikiLocationIdRoute
  AuthDashboardIndexRoute: typeof AuthDashboardIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLocationWikiLocationIdRoute: AuthLocationWikiLocationIdRoute,
  AuthDashboardIndexRoute: AuthDashboardIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicSignInRoute: typeof PublicSignInRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicSignInRoute: PublicSignInRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
